import React from "react";
import Modal from "react-modal";

export default function ModalComponent({ onClose, children, className }) {
  return (
    <Modal isOpen={true} className="modal-container" onClose={onClose}>
      <div className={`modal-card card ${className}`}>{children}</div>
    </Modal>
  );
}
